import React from "react";
import axios from "axios";
import { login as API_LOGIN } from "./config/api";
import { sys as API_SYS } from "./config/api";
import { setup as URI_SETUP, host as ROOT_DIR } from "./config/api";
import Login from "./Login";
import ResetPassword from "./ResetPassword";
//Componentes
import Header from "./components/Header";
import SidebarLeft from "./components/SidebarLeft";
import SidebarNotifications from "./components/SidebarNotifications";
import { Drawer } from 'antd';

//Layouts
import LayoutAccount from "./modules/account/Layout.js";
import LayoutSetup from "./modules/setup/Layout.js";
import LayoutSupport from "./modules/support/Layout.js";
import LayoutLegal from "./modules/legal/Layout.js";

const postUrlLogin = API_LOGIN;
const sysUrl = API_SYS;
const uri_notifications = URI_SETUP+"notifications";
const uri_hotels = URI_SETUP+"hotel";
const uri_data_source_csv = URI_SETUP+"data_source/csv/schema";
const uri_catalogs = URI_SETUP+"catalog";
const uri_roles = URI_SETUP+"userrole_role";
const uri_users = URI_SETUP+"userrole";
const uri_contract = URI_SETUP+"user_contract";

class SetupApp extends React.Component{
  
  constructor(props){
    super(props);
    this.state = {
      first_request             : true,
      isVisible                 : "loading-wait",
      layout_active             : "account",
      section_active            : "account-data",
      hotel_selected            : "",
      status_sb_notifications   : false,
      is_login                  : true,
      forgot_password           : false,
      sys_catalogs              : [],
      sys_tree                  : [],
      hotels                    : [],
      parsing_schema_list       : [],
      lst_notifications         : [],
      lst_tmp_notifications     : [],
      lst_seasons               : [],
      item_active               : "",
      sys_tags                  : {
                                    target_market               : [],
                                    hotel_direct_competition    : []
                                  },
      roles                     : [],
      users                     : [],
      editing_user              : "",
      business_id               : "",
      user_id                   : "",
      loading_users             : true,
      show_noti                 : false,
      editing_business          : "",
      contracts_resume          : []
    }
    this.setSession = this.setSession.bind(this);
    this.activeSection = this.activeSection.bind(this);
    this.refreshCatalogSys = this.refreshCatalogSys.bind(this);
    this.updateCatalogCounter = this.updateCatalogCounter.bind(this);
    this.getHotels = this.getHotels.bind(this);
    this.setActiveHotel = this.setActiveHotel.bind(this);
    this.renderSelectHotels = this.renderSelectHotels.bind(this);
    this.openStatusNotifications = this.openStatusNotifications.bind(this);
    this.handleNotification = this.handleNotification.bind(this);
    this.getRoles = this.getRoles.bind(this);
    this.getUsers = this.getUsers.bind(this);
    this.setEditingUser = this.setEditingUser.bind(this);
    this.setEditingBusiness = this.setEditingBusiness.bind(this);
    this.setForgot = this.setForgot.bind(this);
  }
  
  componentWillMount(){
    this.verifyToken();
    // if(this.state.is_login){
    //   this.loadView();
    // }
  }

  componentDidMount(){
    this.timer = setInterval(
      () => this.loadNotificationQueue(),
      30000,
    ); 
  }

  loadView(){
    this.getHotels();
    this.sysStartup();
    this.getRoles();
  }
  // ----------------------- Handlers -----------------------

  handleHotelChange = (event) => {
    this.setActiveHotel(event.target.value);
  }

  handleNotification(type,action,msg,key){
    
    if(type=="tmp"){
      const lst_tmp_notifications = this.state.lst_tmp_notifications;
      this.openStatusNotifications();
      
      switch(action){
        case 'new':
          lst_tmp_notifications.push(msg);
          key=lst_tmp_notifications.length-1;
          break;
        case 'update':
          lst_tmp_notifications[key]=msg;
          break;
        case 'remove':
          lst_tmp_notifications.splice(key, 1);
          break;
      }

      this.setState({
        lst_tmp_notifications
      });

    }else{

      switch(action){
        case 'remove':
          let data = {
            api_token : localStorage.getItem("api_token")
          };
          let qs = require("qs");
          axios.post(uri_notifications+"/"+key+"/destroy", qs.stringify(data))
              .then(request => {
                  this.loadNotificationQueue();   
          })

          break;
      }

    }
    
    return key;
    
  }

  getRoles() {
    let self = this;
    axios.get(uri_roles, { 
        params: {
            api_token   : localStorage.getItem("api_token")
        }
    }).then(request => { 
        self.setState({ 
        roles                  : request.data
        }) 
    })
  } 

  getUsers(business_id) {
    let self = this;
    self.setState({
      loading_users : true
    })
    axios.get(uri_users, { 
        params: {
            api_token   : localStorage.getItem("api_token"),
            business_id : business_id
        }
    }).then(request => { 
        self.setState({ 
            users  : request.data,
            loading_users : false
        }) 
    })
  } 

  // getContract() {
  //   let self = this;
  //   axios.get(uri_contract, { 
  //       params: {
  //           api_token   : localStorage.getItem("api_token")
  //       }
  //   }).then(request => { 
  //       self.setState({ 
  //         business_id  : request.data["contract_id"]
  //       }) 
  //       self.getUsers(self.state.business_id);
  //   })
  // } 



  // ----------------------- Functions -----------------------

  loadNotificationQueue(){
    let self = this;
    if(localStorage.getItem("api_token")!=undefined){
      axios.get(uri_notifications, { 
          params: {
              api_token   : localStorage.getItem("api_token")
          }
      }).then(request => {
          self.setState({ 
            lst_notifications     : request.data
          }); 
      });
    }
  }

  sysStartup() {
    let self = this;
    axios.get(sysUrl+"startup", { 
        params: {
            api_token   : localStorage.getItem("api_token")
        }
    }).then(request => {
        
        self.setState({ 
          sys_catalogs          : request.data.catalogs,
          sys_tree              : request.data.tree,
          sys_tags              : request.data.tags,
          contracts_resume      : request.data.contracts_resume,
          show_noti             : request.data.show_noti
        });
        
        if(request.data.show_noti){
          const lst_tmp_notifications = this.state.lst_tmp_notifications;
          let hotels_pending = [];
          request.data.catalogs.map(function(catalog) {
            if(catalog.pendings>0){
              self.state.hotels.map(function(hotel) {
                if(catalog[hotel._id].pendings>0){
                  if(hotels_pending[hotel._id]==undefined){ hotels_pending[hotel._id]=[]; }
                  if(hotels_pending[hotel._id]['pendings']==undefined){ hotels_pending[hotel._id]['pendings']=""; }
                  
                  hotels_pending[hotel._id]['name']=hotel.name;
                  hotels_pending[hotel._id]['pendings'] = hotels_pending[hotel._id]['pendings'] + ('<li>'+catalog[hotel._id].pendings + " " + catalog.name.en+'</li>');
                }
              });

            }
          });

          //console.log(hotels_pending);

        Object.keys(hotels_pending).map(function(key) {
          var d = new Date();
          let msg = { 
            title               : "IMPORTATIONS",
            msg                 : "You have some Catalogs pending to parse in " + hotels_pending[key].name +"<ul>"+ hotels_pending[key].pendings + "</ul>",
            day                 : "Today",
            datetime            : d.getFullYear() + "-" + ("0"+(d.getMonth()+1)).slice(-2) + "-" + ("0" + d.getDate()).slice(-2) +
                                  " " + ("0" + d.getHours()).slice(-2) + ":" + ("0" + d.getMinutes()).slice(-2),
            layout              : "setup",
            section             : "parsing-db",
            hotel_selected      : key,
            item_active         : "",
            };
          lst_tmp_notifications.push(msg);
        }); 
        
        
        if(lst_tmp_notifications.length>0){
          self.setState({ lst_tmp_notifications });
          this.openStatusNotifications();
        }

        }

        
    })

  }

  getSeasons(){
    let self = this;
    axios.get(uri_catalogs+"/season", { 
        params: {
            api_token           : localStorage.getItem("api_token"),
            property_id         : self.state.hotel_selected,
        }
    }).then(request => { 
        if(request.data.length>0){
            self.setState({ 
                lst_seasons             : request.data
                }) 
        }else{
            self.setState({ 
                catalog_items_found             : []
                }) 
        }
    })
  }

  refreshCatalogSys($property_id) {
    let self = this;

    axios.get(sysUrl+"catalog", { 
        params: {
            api_token   : localStorage.getItem("api_token"),
            property_id : $property_id
        }
    }).then(request => {
        self.setState({ 
          sys_catalogs          : request.data
        }) 
    })

  }

  updateCatalogCounter(catalog,property_id,amount,action='add') {
    let self = this;
    let sys_catalogs = self.state.sys_catalogs;
    let key = sys_catalogs.findIndex(c => c._id === catalog._id);
    if(action=='rewrite'){
      sys_catalogs[key][property_id].pendings = amount;
    }else{
      sys_catalogs[key][property_id].pendings += amount;
    }
    
    self.setState({ sys_catalogs })

  }

  activeSection(layout,section,hotel_selected,item_active){
    let self = this;
    if(hotel_selected!=''){
      self.setActiveHotel(hotel_selected)
    }
    
    self.setState({
      layout_active : layout,
      section_active : section,
      hotel_selected : hotel_selected,
      item_active    : item_active
    })
  }

  setSession(state){
    let self = this;
    self.setState({
      is_login : state      
    })
    if(state){
      this.verifyToken();
    }
  }

  setForgot(state){
    let self = this;
    self.setState({
      forgot_password : state      
    })
  }
  setEditingUser(user_id){
    let self = this;
    self.setState({
      editing_user : user_id,      
    })
  }
  setEditingBusiness(business_id){
    let self = this;
    self.setState({
      editing_business : business_id,      
    })
  }

  verifyToken(){
    let self = this;
    let host = window.location.host;
    let parts = host.split(".");
    let subdomain = "";
    if (parts.length >= 3) {
        subdomain = parts[0];
    }else{
        subdomain = 'app-test';
    }
    if(self.state.isVisible === "loading-wait"){
      let data = {
        api_token : localStorage.getItem("api_token"),
        subdomain : subdomain
      };
      let qs = require("qs");
      axios.post(postUrlLogin, qs.stringify(data))
      .then(function (response) {
          if ( response.data["status"] === "error" ){
              localStorage.removeItem("api_token");
              localStorage.removeItem("name");
              localStorage.removeItem("email");
              self.setState({
                is_login : false,
                first_request : true,
              })
          }else{
            self.setState({
              is_login : true,
              isVisible : "",
              business_id : response.data["business_id"],
              user_id : response.data["user_id"]
            }, function(){
              setTimeout(() => {
                self.setState({
                  isVisible: "loading-success",
                  first_request : false
                })
                self.loadView();
                self.getUsers(self.state.business_id);
              }, 1000);
            })
          }
      })
      .catch(function (error) {
      });
    }
  }

  openStatusNotifications(){
    this.setState({ 
      status_sb_notifications : true
      }) 
  }

  setActiveHotel(hotel){
    hotel= (hotel==='')? this.state.hotel_selected : hotel;
    let self = this;
    axios.get(uri_data_source_csv, { 
      params: {
          api_token   : localStorage.getItem("api_token"),
          property    : hotel
      }
    }).then(request => { 
        self.setState({ 
            parsing_schema_list : request.data,
            hotel_selected : hotel 

            }) 
        }) 
    
    self.getSeasons();
    
  }

  getHotels() {
    let self = this;
    axios.get(uri_hotels, { 
        params: {
            api_token   : localStorage.getItem("api_token")
        }
    }).then(request => { 
        self.setState({ 
        hotels                  : request.data
        }) 
    })
  } 

  onCloseNotifications = () => {
    this.setState({
      status_sb_notifications: false,
    });
  };


  // ----------------------- Renders -----------------------

  renderSelectHotels() {
    return  <select className="form-control top-form-select " name="hotel_id" value={this.state.hotel_selected}  onChange={this.handleHotelChange.bind(this)}  >
                <option disabled>HOTEL</option>
                {Object.keys(this.state.hotels).map((key, index) => {
                    return ( <option value={this.state.hotels[key]._id} key={index}> {this.state.hotels[key].name}</option>);
                    })
                }
            </select> 
  }


  renderNotifications() {
      let self = this;
      return <ul>
                  {   
                      self.state.lst_notifications.map(function(msg, i) {
                              return (<li className="item" key={i}>
                              <ul>
                                  <li className="header regular">
                                      {msg.title}
                                      <i className="fa fa-times-circle remove clickable" onClick={self.handleNotification.bind(this,"remote","remove","",msg._id)}></i>
                                  </li>
                                  <li className="details">    
                                      
                                      <div className="message">
                                          <p>{msg.msg}</p>
                                        <div className="progress">
                                            <div className="progress-bar bg-success" style={{width:msg.progress+"%"}} role="progressbar" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                        </div>
                                      </div>
                                      <div className="datetime">
                                          <i className="clock"></i>
                                          <span className="days">today</span>
                                          <span className="time">{msg.datetime.$date.$numberLong}</span>
                                      </div>
                                  </li>
                      
                              </ul>
                      
                          </li>);
                          })
                  }
              </ul>   
  }

renderNotificationsTmp() {
      let self = this;
      return <ul>
                  {   
                      this.state.lst_tmp_notifications.map(function(msg, i) {
                              return (<li className="item" key={i}>
                              <ul>
                                  <li className="header regular">
                                      {msg.title}
                                      <i className="fa fa-times-circle remove clickable" onClick={self.handleNotification.bind(this,"tmp","remove","",i)}></i>
                                  </li>
                                  <li className="details">
                                      <div className="message">
                                        <div className="mg-content" dangerouslySetInnerHTML={{__html: msg.msg}} />
                                        <div className="progress">
                                            <div className="progress-bar bg-success" style={{width:msg.progress+"%"}} role="progressbar" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                        </div>
                                      </div>
                                      <div className="datetime">
                                          <i className="clock"></i>
                                          <span className="days">{ msg.datetime }</span>
                                          { (msg.layout!=undefined) &&
                                              <span className="time"><i className="fa fa-link clickable" onClick={self.activeSection.bind(self,msg.layout,msg.section,msg.hotel_selected,msg.item_active)}></i> </span>
                                          }
                                      </div>
                                  </li>
                      
                              </ul>
                      
                          </li>);
                          })
                  }
              </ul>   
  }
  
  render(){
    let self = this;
    let host = window.location.host;
    let parts = host.split(".");
    let subdomain = "";
    if (parts.length >= 3) {
        subdomain = parts[0];
    }else{
        subdomain = 'app-test';
    }

    if(this.state.is_login){
      return(
        <div className="container-general">
            <div className={ "loading-general " + this.state.isVisible }>
              <span
                style={{
                    background : 'url(' + ROOT_DIR + "uploads/" + subdomain + "/logo_old.svg" + ') center center no-repeat',
                    backgroundSize : 600
                }} />
            </div>
            <Header
              setSession={this.setSession}
              openStatusNotifications = {this.openStatusNotifications}
              notificationsCount = {this.state.lst_notifications.length + this.state.lst_tmp_notifications.length }
              newsCount = {0}
            />
            <main className="container-fluid main-container">
              <SidebarLeft
                setSession={this.setSession}
                activeSection={this.activeSection}
                setActiveHotel = {this.setActiveHotel}
                menu={this.state.sys_tree}
                hotels={this.state.hotels}
                app={this}
              />
              <div className="content">
                <div className={"account " + (this.state.layout_active !== "account" ? "hide" : "") }>
                <LayoutAccount
                    app={this}
                    openStatusNotifications={this.openStatusNotifications}
                    activeSection={this.activeSection}
                    handleNotification={this.handleNotification}
                    hotels={this.state.hotels}
                    business_id={this.state.business_id}
                    roles={this.state.roles}
                    users={this.state.users}
                    getUsers = {this.getUsers}
                    setEditingUser = {this.setEditingUser}
                    editing_user = {this.state.editing_user}
                    loading_users = {this.state.loading_users}
                    user_id = {this.state.user_id}
                    setEditingBusiness = {this.setEditingBusiness}
                    editing_business = {this.state.editing_business}
                  />
                </div>
                <div className={"setup " + (this.state.layout_active !== "setup" ? "hide" : "") }>
                  <LayoutSetup
                    catalogs={this.state.sys_catalogs}
                    refreshCatalogSys={this.refreshCatalogSys}
                    updateCatalogCounter={this.updateCatalogCounter}
                    setActiveHotel = {this.setActiveHotel}
                    getHotels = {this.getHotels}
                    renderSelectHotels = {this.renderSelectHotels}
                    openStatusNotifications={this.openStatusNotifications}
                    activeSection={this.activeSection}
                    handleNotification={this.handleNotification}
                    app={this}
                    hotel_selected = {this.state.hotel_selected}
                    item_active = {this.state.item_active}
                    sys_tags = {this.state.sys_tags}
                    hotels={this.state.hotels}
                    business_id={this.state.business_id}
                    roles={this.state.roles}
                    users={this.state.users}
                    getUsers = {this.getUsers}
                    setEditingUser = {this.setEditingUser}
                    editing_user = {this.state.editing_user}
                    loading_users = {this.state.loading_users}
                    contracts_resume = {this.state.contracts_resume}
                    setEditingBusiness = {this.setEditingBusiness}
                    editing_business = {this.state.editing_business}
                  />
                </div>
                <div className={"support " + (this.state.layout_active !== "support" ? "hide" : "") }>
                  <LayoutSupport
                    //app={this}
                  />
                </div>
                <div className={"legal " + (this.state.layout_active !== "legal" ? "hide" : "") }>
                  <LayoutLegal
                    //app={this}
                  />
                </div>


              </div>

            </main>
                
            <Drawer
              title="Notifications"
              placement="right"
              closable={true}
              onClose={this.onCloseNotifications}
              visible={this.state.status_sb_notifications}
              width="330px"
            >
              <div className="list">
                  {this.renderNotificationsTmp()}
              </div>
              <div className="list">
                  {this.renderNotifications()}
              </div>
            </Drawer>

        </div>
      )
    }else{
      if(this.state.forgot_password){
        return (
          <div>
            <ResetPassword
              setForgot = {this.setForgot}
            />
          </div>
        )
      }else{
        return (
          <div>
            <Login 
              setSession={this.setSession}
              setForgot={this.setForgot}
            />
          </div>
        )
      }
    }
  }
};
export default SetupApp


// WEBPACK FOOTER //
// ./src/Setup/App.js